import { Button, ListBox, ListBoxItem, Select, SelectValue } from '@coop/components';
import { ChevronUpIcon } from '@coop/icons';

interface VariantProp {
    id: number | string;
    name: string;
}

type VariantSelectorProps = {
    'aria-label'?: string;
    variants: VariantProp[];
    selectedVariantId?: string;
    handleVariantChange: (variantId: string) => void;
    renderSelectedText?: (selectedText: string | null) => React.ReactNode;
    triggerFullWidth?: boolean;
};

const VariantSelector = (props: VariantSelectorProps) => {
    if (!props.variants.length) return null;

    const sortedVariants = [...props.variants].sort(
        (a, b) => a.name.length - b.name.length || a.name.localeCompare(b.name),
    );

    return (
        <Select
            value={props.selectedVariantId}
            onChange={(k) => {
                if (k) {
                    props.handleVariantChange(k.toString());
                }
            }}
            aria-label="Variant"
            popoverProps={{ placement: 'bottom' }}
            renderSelectedText={props.renderSelectedText}
            triggerSlot={
                <Button
                    size="default"
                    theme="outlined"
                    icon={<ChevronUpIcon />}
                    fullWidth={props.triggerFullWidth}
                >
                    <SelectValue />
                </Button>
            }
        >
            <ListBox items={sortedVariants}>
                {(item) => (
                    <ListBoxItem key={item.id} id={item.id.toString()}>
                        {item.name}
                    </ListBoxItem>
                )}
            </ListBox>
        </Select>
    );
};

export default VariantSelector;
